import React from 'react';
import PropTypes from 'prop-types';

import clone from 'clone-deep';

import SelectedItemDisplay from './SelectedItemDisplay';

const SelectedItemDisplayList = (props) => {
  const removeItem = (e) => {
    let target = e.target;
    while (!target.classList.contains('remove-item')) {
      target = target.parentElement;
    }
    const index = target.dataset.index;
    let newArrayList = null;
    if (props.arrayList.length > 1) {
      newArrayList = clone(props.arrayList);
      newArrayList.splice(index, 1);
    }
    props.updateCDF(props.field, newArrayList);
    if (typeof props.onRemove === 'function') {
      props.onRemove(index);
    }
  };
  const items = props.arrayList.map((v, i) => (
    <SelectedItemDisplay
      arrayItems={v}
      index={i}
      // eslint-disable-next-line react/no-array-index-key
      key={i}
      removeItem={removeItem}
      controlList={props.controlList}
      cdf={props.cdf}
      updateCDF={props.updateCDF}
      getTitle={props.getTitle}
      onChange={props.onChange}
      storedList={props.storedList}
      template={props.template}
      mode={props.mode}
      expanded={props.mode === 'edit' && v.length < 1}
    />
  ));
  return (
    <div>
      {items}
    </div>
  );
};

SelectedItemDisplayList.propTypes = {
  arrayList: PropTypes.array.isRequired,
  mode: PropTypes.oneOf([
    'display',
    'edit',
  ]).isRequired,
};

export default SelectedItemDisplayList;



// WEBPACK FOOTER //
// ./app/components/FormControls/ListEditor/SelectedItemDisplayList.js